<script>
import {city} from "@/assets/js/city";

export default {
  name: "customCityCascader",
  props: {
    value: {
      type: String,
      default: ''
    },
    show:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fieldNames: {
        text: 'name',
        value: 'name',
        children: 'children',
      },
      city: city,
      actionArea: '',
      cascaderValue: '',
      showCity: false,
      activeTab: 2, // 0: 省, 1: 市, 2: 区
    }
  },
  computed: {
    maxLevel() {
      return this.activeTab + 1; // 省是1级，市是2级，区是3级
    },
    filteredCity() {
      // 深拷贝原始数据
      const deepClone = (data) => {
        return JSON.parse(JSON.stringify(data));
      };
      
      // 根据层级过滤数据
      const filterByLevel = (data, level) => {
        if (level === 0) {
          // 省级：移除所有子节点
          return data.map(item => ({
            name: item.name,
            code: item.code
          }));
        }
        
        if (level === 1) {
          // 市级：保留省和市，移除区
          return data.map(province => ({
            ...province,
            children: province.children?.map(city => ({
              name: city.name,
              code: city.code
            }))
          }));
        }
        
        // 区级：保留完整数据
        return data;
      };
      
      return filterByLevel(deepClone(city), this.activeTab);
    }
  },
  watch: {
    value: {
      handler() {
        if (this.value) {
          this.actionArea = this.value
        }
      },
      deep: true,
      immediate: true
    },
    show(){
      this.showCity = this.show
    }
  },
  methods: {
    onFinish({selectedOptions}) {
      if (!selectedOptions || selectedOptions.length === 0) return;
      this.actionArea = selectedOptions.map((option) => option.name).join(',');
      this.$emit('input', this.actionArea)
      this.close()
    },
    onChange({value, selectedOptions}) {
      this.cascaderValue = value;
      if (selectedOptions && selectedOptions.length > 0) {
        // 如果选择的层级达到了设定的最大层级，自动确认
        if (selectedOptions.length === this.maxLevel) {
          this.actionArea = selectedOptions.map((option) => option.name).join(',');
          this.confirm();
        } else {
          this.actionArea = selectedOptions.map((option) => option.name).join(',');
        }
      }
    },
    close() {
      this.$emit('input', this.actionArea)
      this.$emit('close', false)
    },
    confirm() {
      // 获取当前选择的层级数
      const currentLevel = this.actionArea ? this.actionArea.split(',').length : 0;
      
      // 如果没有选择或层级不匹配，提示用户
      if (!this.actionArea || currentLevel !== this.maxLevel) {
        this.$toast(`请选择到${['省', '市', '区'][this.activeTab]}级`);
        return;
      }
      
      this.$emit('input', this.actionArea);
      this.close();
    },
    setLevel(level) {
      this.activeTab = level;
      // 清空选择的值
      this.cascaderValue = '';
      this.actionArea = '';
    },
    selectAll() {
      this.actionArea = '全国';
      this.$emit('input', this.actionArea);
      this.close();
    }
  }
}
</script>

<template>
  <div class="customCityCascader">
    <van-popup v-model="showCity" @close="close" round :closeable="false"   position="bottom">
      <div class="cascader-container">
        <div class="cascader-header">
          <div class="level-tabs">
            <div 
              class="tab-item" 
              :class="{ active: false }" 
              @click="selectAll"
            >全国</div>
            <div 
              class="tab-item" 
              :class="{ active: activeTab === 0 }" 
              @click="setLevel(0)"
            >省</div>
            <div 
              class="tab-item" 
              :class="{ active: activeTab === 1 }" 
              @click="setLevel(1)"
            >市</div>
            <div 
              class="tab-item" 
              :class="{ active: activeTab === 2 }" 
              @click="setLevel(2)"
            >区</div>
          </div>
          <span class="confirm" @click="confirm">确定</span>
        </div>
        <van-cascader
            :closeable="false"
            active-color="#0a1450"
            v-model="cascaderValue"
            :options="filteredCity"
            :field-names="fieldNames"
          
            @change="onChange"
            @finish="onFinish"
        />
      </div>
    </van-popup>
  </div>
</template>

<style scoped lang="scss">

.customCityCascader{
  :deep(.van-cascader){
    .van-cascader__header{
      height: 0;
    }
  }
}
.cascader-container {
  .cascader-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid #eee;

    .level-tabs {
      display: flex;
      gap: 12px;

      .tab-item {
        padding: 4px 16px;
        border-radius: 4px;
        font-size: 14px;
        color: #666;
        background: #f5f5f5;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #0a1450;
        }

        &:first-child {
          background: #e8f3ff;
          color: #0a1450;
        }
      }
    }

    .confirm {
      color: #0a1450;
      font-size: 14px;
      padding: 4px 8px;
      cursor: pointer;
    }
  }
}
</style>